module.exports = __webpack_public_path__ + "static/media/img-home-overview-exhibits.18247407.jpg";